import React from "react";
import { ClockCounterClockwise, Trash } from "@phosphor-icons/react";
import { usePlayer } from "../context/PlayerContext";
import { StationGrid } from "../components/StationGrid";

export default function History() {
  const { history, clearHistory } = usePlayer();

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold/15 text-gold">
            <ClockCounterClockwise size={24} weight="duotone" />
          </span>
          <div>
            <h1 className="font-heading text-3xl font-light tracking-tight text-foreground">Recently Played</h1>
            <p className="font-mono text-xs text-muted2">{history.length} stations</p>
          </div>
        </div>
        {history.length > 0 && (
          <button
            data-testid="clear-history-btn"
            onClick={clearHistory}
            className="flex items-center gap-1.5 rounded-full border border-border bg-surface px-4 py-2 text-sm text-muted2 transition-colors hover:text-destructive"
          >
            <Trash size={16} /> Clear
          </button>
        )}
      </div>

      <StationGrid
        stations={history}
        loading={false}
        emptyState={
          <div className="flex flex-col items-center rounded-3xl border border-border bg-surface py-20 text-center">
            <span className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-surfaceHover text-muted2">
              <ClockCounterClockwise size={40} weight="duotone" />
            </span>
            <p className="font-heading text-2xl font-light text-foreground">Nothing played yet</p>
            <p className="mt-2 max-w-sm text-sm text-muted2">
              Start listening and your recent stations will appear here.
            </p>
          </div>
        }
      />
    </div>
  );
}
